var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileMenuRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70711 10.7071C1.31658 11.0976 0.683417 11.0976 0.292893 10.7071C-0.0976311 10.3166 -0.0976311 9.68342 0.292893 9.29289L4.53553 5.05025C4.92606 4.65973 5.55922 4.65973 5.94975 5.05025C6.34027 5.44078 6.34027 6.07394 5.94975 6.46447L1.70711 10.7071Z",
    fill: "#9D9ABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.292893 2.16344C-0.0976315 1.77292 -0.0976315 1.13975 0.292893 0.749228C0.683417 0.358704 1.31658 0.358704 1.70711 0.749227L5.94975 4.99187C6.34027 5.38239 6.34027 6.01556 5.94975 6.40608C5.55922 6.79661 4.92606 6.79661 4.53553 6.40608L0.292893 2.16344Z",
    fill: "#9D9ABA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuRightArrow);
export default __webpack_public_path__ + "static/media/mobile_menu_right_arrow.49c20eda.svg";
export { ForwardRef as ReactComponent };